import { z } from 'zod';

import { SUPPLIER_REQUEST_ACTION } from '../constants';

export const zodSupplierRequestActionBodySchema = z.object({
  action: z.enum(SUPPLIER_REQUEST_ACTION),
  companyId: z.uuid().nullish(),
  rejectionReason: z.string().nullish(),
});
